import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckmarkOutlinedIconBig = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props}>
            <path
                fill="none"
                d="M50.3996 25.9521V28.0129C50.3969 32.8433 48.8327 37.5434 45.9405 41.4122C43.0483 45.281 38.983 48.1113 34.3508 49.4808C29.7186 50.8504 24.7679 50.686 20.2368 49.012C15.7058 47.338 11.8372 44.2442 9.20816 40.1919C6.57909 36.1397 5.33034 31.3462 5.64817 26.5263C5.96599 21.7063 7.83335 17.1183 10.9718 13.4464C14.1102 9.77443 18.3514 7.21537 23.0631 6.15085C27.7747 5.08632 32.7042 5.57335 37.1164 7.53932"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fill="none"
                d="M50.3996 11.2L26.3983 36.4L19.5996 28.45"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
